import {
  useSettingsStore,
  type MenuBackgroundMode,
  type VfxQuality,
} from '../../store/settingsStore';
import { Segmented } from './Segmented';

const VFX_OPTIONS: { value: VfxQuality; label: string }[] = [
  { value: 'high', label: 'High' },
  { value: 'low', label: 'Low (lighter effects and arena)' },
];

const BACKGROUND_OPTIONS: { value: MenuBackgroundMode; label: string }[] = [
  { value: 'animated', label: 'Animated' },
  { value: 'static', label: 'Static' },
  { value: 'off', label: 'Off' },
];

/** Options → Graphics: effects and arena detail, the Home backdrop and auto-fullscreen. */
export function GraphicsTab() {
  const vfxQuality = useSettingsStore((s) => s.vfxQuality);
  const setVfxQuality = useSettingsStore((s) => s.setVfxQuality);
  const menuBackground = useSettingsStore((s) => s.menuBackground);
  const setMenuBackground = useSettingsStore((s) => s.setMenuBackground);
  const autoFullscreen = useSettingsStore((s) => s.autoFullscreen);
  const setAutoFullscreen = useSettingsStore((s) => s.setAutoFullscreen);
  return (
    <>
      <Segmented
        label="Effects detail"
        options={VFX_OPTIONS}
        value={vfxQuality}
        onChange={setVfxQuality}
      />
      <Segmented
        label="Menu background"
        options={BACKGROUND_OPTIONS}
        value={menuBackground}
        onChange={setMenuBackground}
      />
      <label className="option-check">
        <input
          type="checkbox"
          checked={autoFullscreen}
          onChange={(e) => setAutoFullscreen(e.target.checked)}
        />
        Auto-fullscreen on game start
      </label>
    </>
  );
}
